export default __webpack_public_path__ + "img/sagoo/sagoo2_1500.webp";